export const BASE_URL = 'https://connections-api.herokuapp.com';

export const AUTH_TYPES = { REGISTER: 'registration', LOGIN: 'login' };

export const MESSAGE_TYPES = {
  ERROR: 'error',
  NO_RESULTS: 'noResults',
};
